jQuery(document).ready(function () {
    $(document).on('click', '.dnJs-toggleClass', function (e) {
        var button = $(this);
        var containerClass = button.attr('data-container-class');
        var containerId = button.attr('data-container-id');
        var containerToggleClass = button.attr('data-toggle-class');

        if (containerId) {
            var container = $(containerId);
        }
        else if (containerClass) {
            var container = button.closest(containerClass);
        }
        else {
            return false;
        }

        container.toggleClass(containerToggleClass);
    });
});